import React from 'react';
import { TooltipButton } from '../tooltips';

/** Container for a set of input buttons, consisting of these elements
 * - A title (`props.title`)
 * - Any number of input buttons, provided as `props.children`
 */
const InputSet = (props) => {
  const getTooltip = () => {
    if (props.tooltipText) {
      return <TooltipButton text={props.tooltipText}/>;
    }
  }

  return (
    <div className="game-input-set">
      <div>
        {props.title}
        {getTooltip()}
      </div>
      <div>
        {props.children}
      </div>
    </div>
  )
}

export default InputSet;